<template>
    <div>

        <config-main-title>
            Teto de Atendimento
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()" :disabled="edicao_datas">
                        Incluir Teto de Atendimento
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum Teto de Atendimento identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Teto de Atendimento'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span class="badge badge-secondary mr-2">
                            #{{ dado.id_teto_atendimento }}
                        </span>

                        <big data-toggle="tooltip" data-placement="top" title="Teto para data futura" 
                            v-if="dado.dt_inicio_vigencia > $util.hoje()">
                            <i class="fas fa-plane-departure mr-2"></i>
                        </big>
                        <big data-toggle="tooltip" data-placement="top" title="Teto com vigência já passada" 
                            v-if="dado.dt_final_vigencia < $util.hoje()">
                            <i class="fas fa-history mr-2"></i>
                        </big>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div class="d-flex" v-else>
                            <h5 class="mb-0 ml-1">
                                <span v-if="dado.fl_limite_qtde" class="badge badge-secondary">
                                    {{ dado.in_teto_qtde }}
                                </span>
                            </h5>
                            <h5 class="mb-0 ml-1">
                                <span v-if="dado.fl_limite_valor" class="badge badge-secondary">
                                    R$ {{ $util.formatMoeda(dado.dc_teto_valor) }}
                                </span>
                            </h5>
                            <button type="button" class="btn btn-sm btn-outline-primary ml-1" @click="editar_datas(dado)"
                                v-if="dado.st_frequencia == 'D' || dado.st_frequencia == 'H'">
                                <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                            </button>
                        </div>
                    </span>
                </li>
            </div>

            <template v-if="edicao_datas">
                <div class="card dashcard mt-3">
                    <div class="card-body">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-periodo v-model="filtro" :sync="true" @sync="load_datas()" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <button type="button" class="btn btn-outline-primary" @click="incluir_data()">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <az-empty-state v-if="!edicao_datas.datas" />

                <template v-else>
                    <div class="list-group mb-3 az-anime-surgir mb-3">
                        <li class="list-group-item d-flex justify-content-between" v-for="(itemdata, id) in edicao_datas.datas" :key="id">
                            <div>
                                <a href="#" class="h5 card-link mb-0 mr-3" @click.prevent="editar_data(itemdata)">
                                    {{ $util.getFormatDate(itemdata.dt_atendimento) }}
                                </a>
                            </div>
                            <div>
                                <h5 class="mb-0 ml-1">
                                    <span class="badge badge-secondary">
                                        {{ itemdata.in_teto_qtde }}
                                    </span>
                                </h5>
                            </div>
                        </li>
                    </div>

                    <pre v-if="false">{{ edicao_datas.datas }}</pre>
                </template>
            </template>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_teto_atendimento ? '' : 'Novo' }}
                            Teto de Atendimento
                            <span class="badge badge-secondary ml-2" v-if="item.id_teto_atendimento">
                                #{{ item.id_teto_atendimento }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    placeholder="Informe o título da regra..."
                                    label="Tïtulo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Vigência Inicial"
                                    type="date"
                                    :validate="validate"
                                    required
                                    v-model="item.dt_inicio_vigencia" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Vigência Final"
                                    type="date"
                                    :validate="validate"
                                    required
                                    v-model="item.dt_final_vigencia" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    placeholder="Sem Filtro"
                                    label="Consultas"
                                    type="select"
                                    :optionsList="[
                                        {id: 'I', search: 'Consultas Iniciais'},
                                        {id: 'S', search: 'Consultas Subsequentes'},
                                        {id: 'C', search: 'Consultas Iniciais/Subsequentes'},
                                        {id: 'R', search: 'Consultas de Revisão'},
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.ch_tipo_consulta" />
                            </div>

                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Base de Cálculo"
                                    type="select"
                                    :optionsList="[
                                        {id: 'M', search: 'Marcação'},
                                        {id: 'A', search: 'Atendimento'},
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.st_base" />
                            </div>

                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="number"
                                    label="Idade Mínima do Paciente"
                                    placeholder="0"
                                    v-model="item.in_idade_min" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    type="number"
                                    label="Idade Máxima do Paciente"
                                    placeholder="999"
                                    v-model="item.in_idade_max" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    type="sexo"
                                    placeholder="Qualquer"
                                    label="Sexo do Paciente"
                                    v-model="item.ch_sexo" />
                            </div>
                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <!-- dasdasdas -->
                        <template v-if="1 == 0">
                            <az-sub-title title="Filtros" />
                            <div class="mt-2">
                                <div class="row" v-for="(filtro, ifx) in lista_filtros" :key="ifx">
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            type="button-group"
                                            :optionsList="[{id:1,search:'Apenas'}, {id:0,search:'Exceto'}]"
                                            :validate="validate"
                                            v-model="filtro.fl_regra" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            type="select"
                                            optionsMode="json"
                                            :optionsList="lista_opcoes_filtro"
                                            optionsData="id"
                                            :validate="validate"
                                            required
                                            v-model="filtro.model_type">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" @click="filtro.excluido = true">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>                                
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <input type="text" placeholder="..." class="form form-control" disabled v-if="!filtro.model_type">
                                        <az-input
                                            v-else-if="serviceFiltro(filtro.model_type)"
                                            placeholder
                                            type="autocomplete" 
                                            optionsMode="aql"
                                            :service="serviceFiltro(filtro.model_type)" 
                                            :optionsName="'filtro-' + filtro.model_type"
                                            :optionsParm="{ ativos: true, agenda: true }"
                                            required 
                                            v-model="filtro.model" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <button type="button" class="btn btn-outline-primary btn-sm my-2" @click="incluir_filtro(item)">
                                        <i class="fas fa-plus mr-2"></i>
                                        Incluir Filtro
                                    </button>
                                </div>
                            </div>
                        </template>
                        
                        <az-sub-title title="Limite" />
                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Tempo"
                                    type="select"
                                    optionsMode="json"
                                    :optionsList="[
                                        {id:'D', search:'Diário'}, 
                                        {id:'S', search:'Semanal'}, 
                                        {id:'M', search:'Mensal'}, 
                                        {id:'H', search:'Horário'},
                                        {id:'F', search:'Fatura'},
                                        {id:'P', search:'Paciente'},
                                        {id:'PD', search:'Paciente/Dia'}
                                    ]"
                                    optionsData="id"
                                    :edicao="!item.procedimentos || !item.procedimentos.length"
                                    :validate="validate"
                                    required
                                    v-model="item.st_frequencia" />
                            </div>
                            <template v-if="item.st_frequencia != 'F'">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Escopo"
                                        type="select"
                                        optionsMode="json"
                                        :optionsList="[
                                            {id:'GER', search:'Geral'}, 
                                            {id:'MED', search:'Por Profissional'}, 
                                            {id:'OPER', search:'Por Operadora'}
                                        ]"
                                        optionsData="id"
                                        :validate="validate"
                                        required
                                        v-model="item.st_escopo" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Teto em Quantidade"
                                        type="number"
                                        :validate="validate"
                                        :edicao="item.fl_limite_qtde"
                                        v-model="item.in_teto_qtde">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">
                                                    <input type="checkbox" aria-label="Checkbox for following text input" v-model="item.fl_limite_qtde">
                                                </div>
                                            </div>
                                        </template>
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append input-group-sm" v-if="item.fl_limite_qtde">
                                                <select class="form form-control" v-model="item.ch_tipo_qtde">
                                                    <option value="PAC">Pacientes</option>
                                                    <option value="PRO">Procedimentos</option>
                                                </select>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3" v-if="item.st_base != 'M'">
                                    <az-input
                                        sizing="sm" 
                                        label="Teto em Valor"
                                        type="money"
                                        :validate="validate"
                                        :edicao="item.fl_limite_valor"
                                        v-model="item.dc_teto_valor">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">
                                                    <input type="checkbox" aria-label="Checkbox for following text input" v-model="item.fl_limite_valor">
                                                </div>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </template>
                        </div>
                        <div class="form-row" v-if="item.st_frequencia == 'H'">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"   
                                    label="De"
                                    type="time"
                                    required 
                                    :validate="validate"
                                    v-model="item.hr_dia_inicio" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input   
                                    sizing="sm"
                                    label="Até"
                                    type="time"
                                    required 
                                    :validate="validate"
                                    v-model="item.hr_dia_fim" />
                            </div>
                        </div>

                        <div class="form-row" v-if="( item.st_frequencia == 'D' || item.st_frequencia == 'H' ) && item.st_dias_da_semana">
                            <div class="col col-12 d-flex flex-column">
                                <div class="btn-group input-group-sm mt-2 mb-2" role="group" aria-label="Basic example">
                                    <button type="button" class="btn" 
                                        :class="dia ? 'btn-secondary' : 'btn-outline-secondary'" 
                                        @click="toggle_dia(idia)"
                                        v-for="(dia, idia) in item.st_dias_da_semana" :key="idia">
                                        {{ nome_dia(idia) }}
                                        <i class="fa fa-check ml-2" v-if="dia" aria-hidden="true"></i>
                                        <i class="fa fa-times ml-2" v-else aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Observação"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <div v-if="item.st_frequencia == 'F'" class="my-3">

                            <az-sub-title title="Procedimentos" v-if="item.procedimentos">
                                <a class="card-link" href="#" @click.prevent="incluir_procedimento()">
                                    <i class="fas fa-plus mr-2"></i>
                                    Incluir
                                </a>
                            </az-sub-title>

                            <div v-if="item.procedimentos && !item.procedimentos.length">
                                Nenhum procedimento relacionado
                            </div>

                            <div v-else>
                                <div v-for="(proced, ipx) in item.procedimentos" :key="ipx">
                                    <div class="form-row" v-if="!proced.excluido">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                :label="ipx ? '' : 'Procedimento'"
                                                v-if="!proced.procedimento"
                                                placeholder="Selecione o Procedimento..."
                                                sizing="sm"
                                                type="autocomplete"
                                                :service="'procedimentos.index'"
                                                optionsName="'procedimentos.teto"
                                                :optionsParm="{ ativos: true }"
                                                required
                                                v-model="proced.procedimento">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" @click="proced.excluido = true">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>

                                            <az-input
                                                v-else
                                                :label="ipx ? '' : 'Procedimento'"
                                                sizing="sm"
                                                :edicao="false"
                                                :value="proced.procedimento.search">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" @click="proced.excluido = true">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>

                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                sizing="sm"
                                                :label="ipx ? '' : 'Teto em Quantidade'"
                                                type="number"
                                                :validate="validate"
                                                :edicao="proced.fl_limite_qtde"
                                                v-model="proced.in_teto_qtde">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            <input type="checkbox" aria-label="Checkbox for following text input" v-model="proced.fl_limite_qtde">
                                                        </div>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                sizing="sm" 
                                                :label="ipx ? '' : 'Teto em Valor'"
                                                type="money"
                                                :validate="validate"
                                                :edicao="proced.fl_limite_valor"
                                                v-model="proced.dc_teto_valor">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <div class="input-group-text">
                                                            <input type="checkbox" aria-label="Checkbox for following text input" v-model="proced.fl_limite_valor">
                                                        </div>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-else-if="item.st_base != 'A'">

                            <div class="form-row mt-2">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Permitir atendimento sem agendamento acima do teto"
                                        :validate="validate"
                                        v-model="item.fl_permite_atendimento" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Permitir lançar acima do teto"
                                        :validate="validate"
                                        v-model="item.fl_permite_lancamento" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Aplicável apenas nas marcações no portal"
                                        :validate="validate"
                                        v-model="item.fl_portal" />
                                </div>
                            </div>

                        </template>
                        
                        <az-sub-title title="Mensagem" />
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="textarea"
                                    rows="2"
                                    :validate="validate"
                                    required
                                    v-model="item.st_mensagem" />
                            </div>
                        </div>

                        <br><br><br><br><br>

                        <pre v-if="1==0">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <az-submit color="outline-secondary" @click="clonar()" v-if="item.id_teto_atendimento">
                            Clonar
                        </az-submit>
                        <az-audit-log-button model="tetoAtendimento" :id="item.id_teto_atendimento" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_teto_atendimento ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Datas -->
        <div class="modal fade" id="tetoDataModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="edicao_data">
                    <div class="modal-header">
                        <h5 class="modal-title">Data</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Data"
                                    type="date"
                                    required
                                    :validate="validate"
                                    v-model="edicao_data.dt_atendimento" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Limite (Qtde)"
                                    type="number"
                                    :validate="validate"
                                    v-model="edicao_data.in_teto_qtde" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="edicao_data.st_observacoes" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-submit color="danger" @click="remover_data()" v-if="edicao_data.id_teto_atendimento_data">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_data()">{{ edicao_data.id_teto_atendimento_data ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            filtro: { 
                periodo: 'm', 
            },
            edicao_datas: null, 
            edicao_data: null,
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle,
        AzAuditLogButton,
        FiltroModel, 
        AzPeriodo
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            if ( this.edicao_datas ) {
                return [ 
                    this.edicao_datas, 
                ];
            }

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                // {id:'tag-plano', search:'Classificação do Plano Particular', service: 'planos.index', tag: true},
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'});
            }
            
            return opcoes;
        }
    },

    methods: { 
        incluir_procedimento () { 
            this.item.procedimentos.push({
                id_procedimento: null,
                procedimento: "", 
                excluido: false, 
                fl_limite_qtde: false,
                in_teto_qtde: 0,
                fl_limite_valor: false,
                dc_teto_valor: 0,
            });
        },

        toggle_dia(dia) { 
            this.$set(this.item.st_dias_da_semana, dia, !this.item.st_dias_da_semana[dia]);
        },
        
        nome_dia(dia) { 
            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sab';
            }

            return '?';
        },

        remover_data() { 
            if ( !confirm('Confirma remover essa data?') ) { 
                return;
            }

            this.$util.remover(this, { 
                service: 'teto_atendimento_datas',
                dados: { 
                    id_teto_atendimento_data: this.edicao_data.id_teto_atendimento_data,
                },
                modal: 'tetoDataModal',
                callback: () => { 
                    this.load_datas(true); 
                }
            });
        },

        atualizar_data() { 
            this.$util.atualizar(this, { 
                service: 'teto_atendimento_datas',
                dados: { 
                    ...this.edicao_data,
                    ...this.filtro,
                },
                modal: 'tetoDataModal',
                callback: () => { 
                    this.load_datas(true); 
                }
            });
        },

        incluir_data() { 
            this.edicao_data = { 
                id_teto_atendimento: this.edicao_datas.id_teto_atendimento,
                fl_ativo: true,
                fl_limite_qtde: true, 
                fl_limite_valor: false, 
                in_teto_qtde: 0, 
                st_observacoes: "", 
                dt_atendimento: "", 
            };

            $('#tetoDataModal').modal('show');
        },

        editar_data(data) { 
            this.edicao_data = _.cloneDeep(data);

            $('#tetoDataModal').modal('show');
        },

        load_datas(refresh = false) { 

            if ( !refresh )
                this.edicao_datas.datas = null;

            this.$util.load(this, { 
                service: 'teto_atendimentos',
                func: 'show',
                parms: { 
                    id: this.edicao_datas.id_teto_atendimento,
                    datas: true, 
                    ...this.filtro,
                },
                loadTo: res => { 
                    this.edicao_datas.datas = res.datas;
                }
            });

        },

        editar_datas (item) { 
            if ( this.edicao_datas ) { 
                this.edicao_datas = null;
                return;
            }

            item.datas = null;

            this.edicao_datas = _.cloneDeep(item);
            this.load_datas();
        },

        clonar() { 
            if ( !confirm ("Confirma clonar o item '" + this.item.st_titulo + "'?") )
                return;

            this.$util.atualizar(this, { 
                service: 'cadastros',
                func: 'clonar',
                dados: { 
                    model: 'tetoAtendimento',
                    id: this.item.id_teto_atendimento,
                },
                modal: 'edicaoModal',
                toast: true, 
                reload: true, 
            });
        },

        serviceFiltro(model) {
            switch (model) {
                case 'App\\azure\\medico': return 'medicos.index';
                case 'App\\azure\\unidadeOperacao': return 'unidade_operacaos.index';
                case 'App\\azure\\operadora': return 'operadoras.index';
                case 'App\\azure\\procedimento': return 'procedimentos.index';
            }
            return null;
        },

        incluir_filtro(item) { 
            item.filtros.push({ 
                id_teto_atendimento_filtro: null, 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_teto_atendimento: null, 
                dt_inicio_vigencia: this.$util.hoje(), 
                dt_fim_vigencia: "", 
                hr_dia_inicio: "",
                hr_dia_fim: "",
                st_dias_da_semana: [true,true,true,true,true,true,true],
                st_frequencia: "M",
                in_teto_qtde: "",
                dc_teto_valor: "",
                fl_limite_qtde: false,
                fl_limite_valor: false, 
                st_acao: "I",
                st_observacoes: "",
                st_titulo: "", 
                fl_ativo: true,
                filtros: [],
                procedimentos: [], 
                ch_tipo_consulta: "", 
                st_escopo: "GER",
                ch_tipo_qtde: "PRO",
                st_base: "M"
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'teto_atendimentos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                },
            });
        },
        editar (item) { 
            this.item = null; 

            this.$nextTick(() => { 
                if ( this.edicao_datas ) { 
                    this.edicao_datas = null;
                    return;
                }

                this.validate = false;
                this.item = _.cloneDeep (item);

                if ( !this.item.endereco ) { 
                    this.item.endereco = { cidade: {} };
                }

                $('#edicaoModal').modal('show');
            });
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'teto_atendimentos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'teto_atendimentos',
                dados: item,
            });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Teto de Atendimento", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>